import React from "react";
import CustomText from "../../../common/components/CustomText";
import CheckBox from "../../../assets/images/checkbox.svg";
import CheckedBox from "../../../assets/images/checkbox_check.svg";
export default class TermOption extends React.Component {
    constructor(props){
        super(props);
        // console.log(this.refs);
        this.state = {
            textValue:this.props.textValue,
            checkedValue: this.props.checked
        };

    }
    onClicked(event){
        console.log(event);
        this.setState({checkedValue:event.target.checked});
    }
    render() {
        return (
            <div ref={this.props.customRef} className="term-option" >

                <input
                    type="checkbox"
                    id={"check_"+this.props.customRef}
                    checked = {this.state.checkedValue}
                    onChange = {this.onClicked.bind(this)}
                />
                <label for ={"check_"+this.props.customRef}><span className="checkBox"></span>
                    <CustomText label = {this.props.label} textValue = {this.props.textValue} format = {this.props.format}/>
                </label>

            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/quotes/components/TermOption.jsx